import { stringHelpers } from '@approvalmax/utils';

export const transform = (value: string) => stringHelpers.escapeSpecificExpressions(value, [/[^0-9]/g]);
